// angular
// 	.module("HeroPRO")
// 	.factory("JobFactory", jobFactory);

/* @ngInject */
export default function JobFactory(HPConfig, $http) {
    let activeJob = {},
        isAssignJob = false;

    return {
        assignLead,
        assignApplication,
        hideLead,
        hideApplication,
        unhideLead,
        unhideApplication,
        getSalesReps,
        getHideReasons,
        setActiveJob,
        getActiveJob,
        setAssignJobFlag,
        getAssignJobFlag,
    };

    /*
	 HP-162: Assign a Job Modal (Leads/KBYG)
	 Params: {"PreQualId":1509532,
	 "ContractorUserId":24041,
	 "ContractorLocationId":"18857"}
	 Returns:
	 ContractorUserId: the user that triggered the changed
	 PreQualId
	 PreviosSalesRepContractorUserId
	 PreviosContractorLocationId
	 NewSalesRepContractorUserId: if null means nothing changed
	 NewContractorLocationId: if null means nothing changed

	 */
    function assignLead(params) {
        return $http({
            url: `${HPConfig.heroProApi}KBYG/LocationAndContractorUser`,
            method: 'POST',
            data: params,
        });
    }

    /*
	 HP-162: Assign a Job Modal (Applications/Loans)
	 Params: {"FundingRequestId":319294,
	 "ContractorUserId":24041,
	 "ContractorLocationId":"18857"}
	 Returns:
	 ContractorUserId: the user that triggered the changed
	 FundingRequestId
	 LoanId
	 PreviosSalesRepContractorUserId
	 PreviosContractorLocationId
	 NewSalesRepContractorUserId: if null means nothing changed
	 NewContractorLocationId: if null means nothing changed
	 */
    function assignApplication(params) {
        return $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequest/LocationAndContractorUser`,
            method: 'POST',
            data: params,
        });
    }

    /*
	 HP-1061: Hide a Job Modal (Leads/KBYG)
	 Params: {"PreQualId": (int),
	 "ContractorJobHideReasonTypeId":(int),
	 "Reason": (string)}
	 Returns:
		 PreQualId
		 IsContractorJobHidden
		 ContractorJobHideReasonTypeId
		 ContractorJobHideReason
		 ContractorJobHideDate

	 */
    function hideLead(params) {
        return $http({
            url: `${HPConfig.heroProApi}KBYG/HideFromContractor`,
            method: 'POST',
            data: params,
        });
    }

    /*
	 HP-46: Hide a Job Modal (Applications/Loans)
	 Params: {"FundingRequestId":(int),
	 "ContractorUserId":(int),
	 "ContractorLocationId":(string)}
	 Returns:
		 FundingRequestId
		 IsContractorJobHidden
		 ContractorJobHideReasonTypeId
		 ContractorJobHideReason
		 ContractorJobHideDate
	 */
    function hideApplication(params) {
        return $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequest/HideFromContractor`,
            method: 'POST',
            data: params,
        });
    }

    function unhideLead(params) {
        return $http({
            url: `${HPConfig.heroProApi}KBYG/UnhideFromContractor`,
            method: 'POST',
            data: params,
        });
    }

    function unhideApplication(params) {
        return $http({
            url: `${HPConfig.heroProApi}Loan/FundingRequest/UnhideFromContractor`,
            method: 'POST',
            data: params,
        });
    }

    function getSalesReps(contractorId) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser`,
            method: 'GET',
            params: {
                ContractorLocationIds: contractorId,
                FilterBySalesRep: false,
            },
        });
    }

    function getHideReasons() {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/ContractorJobHideReasonTypes`,
            method: 'GET',
        });
    }

    function setActiveJob(job) {
        activeJob = job;
    }

    function getActiveJob() {
        return activeJob;
    }

    function setAssignJobFlag(isAssign) {
        isAssignJob = isAssign;
    }

    function getAssignJobFlag() {
        return isAssignJob;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/job/jobFactory.js